import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_BLOGS_LIST: string = typeCreatorV2('BlogsReducer', 'SetBlogs');
export const INSERT_BLOG: string = typeCreatorV2('BlogsReducer', 'InsertBlog');
export const UPDATE_BLOG: string = typeCreatorV2('BlogsReducer', 'UpdateBlog');
export const DELETE_BLOG: string = typeCreatorV2('BlogsReducer', 'DeleteBlog');
